export const heroContent = {
  hero: {
    headline: "Top Estimators. Strong Margins. Healthy Pipelines.",
    subheadline:
      "We help Contractors streamline their back office to produce hyper competitive and accurate estimates, consistent flows of work and free up time.",
    buttonText: "Schedule a Call",
  },
  howWeHelp: {
    title: "We Help Contractors Focus On Building. Not Bidding.",
    subtitle: "How We Help",
    paragraph:
      "Stuck between the field and the office? \n Or changing up estimators? \n Our Estimators take estimating off your plate, so you can focus on growing your business. We deliver precise, profitable estimates and systems that help you win a consistent flow of work every month.",
    keyBenefits: [
      {
        icon: "GpsFixedIcon",
        label: "Precise Estimates",
        value: "Fast, accurate, competitive, and profitable estimates",
      },
      {
        icon: "EqualizerIcon",
        label: "Cost Optimization",
        value: "Built using your labor, equipment, and vendor costs",
      },
      {
        icon: "PeopleIcon",
        label: "Relationship Focus",
        value: "Business relationships maintained & nurtured",
      },
      {
        icon: "TrendingUpIcon",
        label: "Consistent Pipeline",
        value: "A consistent full pipeline, month after month",
      },
    ],
  },
  video: {
    title: "Dan Hungerford, Owner Hungerford Consulting",
    wistiaId: "cb0udelhgt",
  },
};
